<template>
  <AppWrapper>
    <template v-if="showAll">
      <TheHeader :nav="menuLinks" @toggleMenu="mobileMenu = !mobileMenu" />

      <AppNavDrawer
        v-if="$core.breakpoint.lgAndDown"
        app
        left
        width="300"
        v-model="mobileMenu"
      >
        <MobileMenu :nav="menuLinks" />
      </AppNavDrawer>
    </template>

    <AppContent :iframe="!showAll">
      <TheBackground />
      <template v-if="showAll">
        <MainPromo />
      </template>
      <LayoutManager />
      <template v-if="showAll">
        <PhotosWidget />
        <PartnersWidget />
        <!-- <MainTagline v-if="$route.name !== 'home'" class="my-3 px-2" /> -->
      </template>
    </AppContent>
    <template v-if="showAll">
      <TheFooter :nav="footerLinks" />
    </template>
  </AppWrapper>
</template>

<script>
import AppWrapper from "@/components/ui/app/AppWrapper";
import AppContent from "@/components/ui/app/AppContent";
import TheHeader from "@/components/common/header/TheHeader";
import TheFooter from "@/components/common/footer/TheFooter";
import AppNavDrawer from "@/components/ui/app/AppNavDrawer";
import MobileMenu from "@/components/common/mobile-menu/MobileMenu";
import LayoutManager from "@/layouts/LayoutManager.vue";
import PhotosWidget from "@/components/photos/PhotosWidget";
import PartnersWidget from "@/components/common/partners/PartnersWidget";
import TheBackground from "@/components/common/TheBackground";
import MainPromo from "@/components/common/promo/MainPromo";
// import MainTagline from "@/components/common/promo/MainTagline";

const iframePaths = ["/registration", "/schedule-iframe", "/brackets/iframe"];

function checkIframe() {
  return iframePaths.includes(window.location.pathname);
}

export default {
  name: "App",

  components: {
    AppWrapper,
    AppContent,
    TheHeader,
    TheFooter,
    AppNavDrawer,
    MobileMenu,
    LayoutManager,
    TheBackground,
    PhotosWidget,
    PartnersWidget,
    MainPromo
    // MainTagline
  },

  data: () => ({
    showAll: !checkIframe(),
    mobileMenu: false,
    menuLinks: [
      { to: "/", exact: true, name: "Главная" },
      { to: "/photos", name: "Фото" },
      { to: "/schedule", name: "Расписание" },
      { to: "/teams", name: "Команды" },
      { to: "/regulations", name: "Регламент" },
      { to: "/brackets", name: "Результаты" },
      { to: "/manual", name: "Как играть?" },
      { to: "/contacts", name: "Контакты" }
    ],
    footerLinks: [
      {
        name: "Политика конфиденциальности",
        href: "https://www.redbull.com/pp/ru_RU",
        target: "_blank"
      },
      {
        name: "Правила & Условия",
        href: "https://www.redbull.com/tou/ru_RU",
        target: "_blank"
      },
      {
        name: "Продукты и компания",
        href: "http://energydrink-ru.redbull.com/",
        target: "_blank"
      },
      {
        name: "Импринт",
        href: "https://www.redbull.com/im/ru_RU",
        target: "_blank"
      },
      {
        name: "Защита бренда",
        href: "https://www.redbull.com/bp/ru_RU",
        target: "_blank"
      },
      {
        name: "Fraud Warning",
        href:
          "https://policies.redbull.com/policies/RedBull.com_International/201910300116/en/fraud_warning.html",
        target: "_blank"
      },
      {
        name: "Медиа",
        href: "https://www.redbullcontentpool.com/",
        target: "_blank"
      },
      {
        name: "Связаться с нами",
        href: "http://energydrink-ru.redbull.com/red-bull-rossiya-kontakti",
        target: "_blank"
      }
    ]
  })

  // computed: {
  //   showAll() {
  //     return !this.$route.query.iframe;
  //   }
  // }
};
</script>
